export const services = [
  {
    id: "deep-tissue",
    name: "Deep Tissue Massage",
    shortDesc: "Firm targeted massage releasing deep muscle tension and chronic knots",
    image: "https://elementsmassage.com/files/shared/EM_DeepTissueMassage.jpeg",
    extraImages: [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80",
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=600&q=80",
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&q=80",
    ],
    badge: "Most Popular",
    durations: [
      { label: "45 min", price: 2000 },
      { label: "60 min", price: 2500 },
      { label: "90 min", price: 3500 },
    ],
    benefits: [
      "Relieves chronic muscle tension",
      "Reduces pain and inflammation",
      "Improves posture and flexibility",
      "Breaks down scar tissue",
    ],
    products: [
      { icon: "droplets", name: "Arnica Oil", desc: "deep penetrating muscle relief oil" },
      { icon: "leaf", name: "Eucalyptus Blend", desc: "cooling anti-inflammatory blend" },
      { icon: "flame", name: "Hot Stone Balm", desc: "warming balm for deep tissue work" },
    ],
    whatToExpect:
      "Brief consultation first. Firm slow strokes target deep muscle layers. Some pressure is normal and leads to deep relief. Post session you feel lighter, looser and deeply relaxed.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20Deep%20Tissue%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
  {
    id: "thai-massage",
    name: "Thai Massage",
    shortDesc: "Ancient healing with acupressure and stretching to energize your whole body",
    image: "https://t4.ftcdn.net/jpg/00/49/84/71/360_F_49847134_GDTYb3FKMNxHDPvZ35OlMPT6G3Wpfkpm.jpg",
    extraImages: [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&q=80",
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80",
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=600&q=80",
    ],
    badge: "Premium",
    durations: [
      { label: "45 min", price: 2500 },
      { label: "60 min", price: 3000 },
      { label: "90 min", price: 5000 },
    ],
    benefits: [
      "Increases flexibility and range of motion",
      "Improves blood circulation",
      "Reduces stress and anxiety",
      "Boosts energy and vitality",
    ],
    products: [
      { icon: "flower2", name: "Thai Herbal Oil", desc: "traditional lemongrass and ginger blend" },
      { icon: "leaf", name: "Peppermint Compress", desc: "herbal compress for pressure points" },
      { icon: "droplets", name: "Coconut Recovery Oil", desc: "post-massage skin hydration" },
    ],
    whatToExpect:
      "Therapist guides body through assisted stretches and rhythmic pressure along energy lines. Stay in comfortable spa wear. Leave feeling energized, flexible and deeply balanced.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20Thai%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
  {
    id: "stress-relief",
    name: "Stress Relief Massage",
    shortDesc: "Full body relaxation massage that melts stress and restores inner calm",
    image: "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2264275.jpg",
    extraImages: [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=600&q=80",
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&q=80",
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=600&q=80",
    ],
    badge: "Most Popular",
    durations: [
      { label: "45 min", price: 3000 },
      { label: "60 min", price: 3800 },
      { label: "90 min", price: 4500 },
    ],
    benefits: [
      "Deep full body relaxation",
      "Relieves anxiety and overthinking",
      "Promotes better sleep",
      "Balances hormones naturally",
    ],
    products: [
      { icon: "flower2", name: "Lavender Aromatherapy Oil", desc: "calming and relaxing blend" },
      { icon: "leaf", name: "Chamomile Infused Lotion", desc: "soothes nervous system" },
      { icon: "sparkles", name: "Himalayan Salt Scrub", desc: "detox and skin renewal" },
    ],
    whatToExpect:
      "Soft lighting, calming music and gentle strokes dissolve tension. Focus on shoulders neck and back — the main stress zones. You leave feeling calm, clear and completely at ease.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20Stress%20Relief%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
  {
    id: "pain-relief",
    name: "Pain Relief Massage",
    shortDesc: "Targeted therapy for back pain, neck pain and joint stiffness",
    image: "https://img.freepik.com/free-photo/physiotherapist-performing-therapeutic-massage-male-client_23-2149143840.jpg?t=st=1775644052~exp=1775647652~hmac=73f148e8b8f202d3fbe618f0d81901e4319ba7311ca82a1ecee61b94f056f72e&w=1480",
    extraImages: [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=600&q=80",
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80",
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=600&q=80",
    ],
    badge: null,
    durations: [
      { label: "45 min", price: 3000 },
      { label: "60 min", price: 3500 },
      { label: "90 min", price: 4000 },
    ],
    benefits: [
      "Targeted pain relief at source",
      "Reduces inflammation",
      "Improves joint mobility",
      "Faster muscle recovery",
    ],
    products: [
      { icon: "flame", name: "Capsaicin Warming Gel", desc: "targets deep pain points" },
      { icon: "leaf", name: "Wintergreen Oil", desc: "natural pain relief and circulation boost" },
      { icon: "droplets", name: "Magnesium Recovery Lotion", desc: "muscle repair and recovery" },
    ],
    whatToExpect:
      "Begins with identifying specific pain areas through consultation. Targeted pressure and warming techniques applied to affected zones. Ideal for chronic pain, sports injuries and desk job fatigue.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20Pain%20Relief%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
  {
    id: "four-hands",
    name: "Signature (4 Hands Massage)",
    shortDesc: "Two therapists in perfect sync — double the hands, double the bliss",
    image: "https://static.spalopia.app/19b952c0-5466-53da-87d8-6c7a89059af4/s3fs-public/rfh-spa-treatments/masaje-4-manos.gif",
    extraImages: [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=600&q=80",
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&q=80",
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&q=80",
    ],
    badge: "Premium",
    durations: [
      { label: "45 min", price: 4000 },
      { label: "60 min", price: 5000 },
      { label: "90 min", price: 7000 },
    ],
    benefits: [
      "Ultimate full body relaxation",
      "Complete body coverage at once",
      "Deep synchronized muscle release",
      "Truly unique luxury experience",
    ],
    products: [
      { icon: "flower2", name: "Rose and Jasmine Luxury Oil", desc: "premium relaxation blend" },
      { icon: "sparkles", name: "24K Gold Serum", desc: "anti-aging luxury skin treatment" },
      { icon: "gem", name: "Pearl Extract Lotion", desc: "brightening and softening" },
    ],
    whatToExpect:
      "Two expert therapists mirror movements in perfect coordination. The synchronized sensation achieves depth of relaxation impossible with one therapist. Truly unforgettable experience.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%204%20Hands%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
  {
    id: "wine-massage",
    name: "Body Polish (wine massage)",
    shortDesc: "Antioxidant-rich wine extracts that nourish, hydrate and rejuvenate skin",
    image: "https://www.healthlandspa.com/uploads/eSuki964KkF2d7H6VJS5ECZgFqtieVPvJadGsXihTlaTUaZCwm1755240534.jpg",
    extraImages: [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&q=80",
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=600&q=80",
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&q=80",
    ],
    badge: null,
    durations: [
      { label: "45 min", price: 2000 },
      { label: "60 min", price: 2500 },
      { label: "90 min", price: 3200 },
    ],
    benefits: [
      "Deep skin nourishment",
      "Powerful anti-aging effect",
      "Intense hydration and glow",
      "Full body deep relaxation",
    ],
    products: [
      { icon: "wine", name: "Red Wine Extract Oil", desc: "antioxidant rich skin nourisher" },
      { icon: "grape", name: "Grape Seed Serum", desc: "deep hydration and anti-aging" },
      { icon: "sparkles", name: "Vitamin C Brightening Lotion", desc: "glow and radiance boost" },
    ],
    whatToExpect:
      "Rich wine-infused oils warmed and applied with long sweeping strokes. Antioxidants absorb into skin while you drift into deep relaxation. Skin feels visibly softer, brighter and moisturized after one session.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20Wine%20Massage%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20availability.",
  },
];

export const premiumServices = [
  {
    id: "hamam-deep-tissue",
    name: "Deep Tissue Massage with Turkish Hamam",
    shortDesc: "The ultimate body ritual — authentic Turkish Hamam steam and scrub followed by powerful deep tissue massage. Complete detox and rejuvenation.",
    image: "https://omasra.com/cdn/shop/files/0J7A1006_1_1_1445x.jpg?v=1717337488",
    extraImages: [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&q=80",
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80",
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=600&q=80",
    ],
    badge: "Premium",
    durations: [
      { label: "60 min", price: 5500 },
      { label: "90 min", price: 7000 },
      // { label: "120 min", price: 10000 },
    ],
    benefits: [
      "Full body detox and cleanse",
      "Deep muscle tension relief",
      "Complete skin exfoliation",
      "Improved blood circulation",
      "Total stress relief",
    ],
    products: [
      { icon: "sparkles", name: "Kessa Hammam Glove", desc: "traditional Turkish exfoliation" },
      { icon: "droplets", name: "Black Soap Beldi", desc: "authentic Moroccan cleansing soap" },
      { icon: "droplets", name: "Argan Oil Body Butter", desc: "post-hamam deep moisturizing" },
      { icon: "leaf", name: "Arnica Deep Muscle Oil", desc: "post-massage recovery" },
    ],
    whatToExpect:
      "Warm steam room Hamam ritual — Kessa glove and Black Soap removes dead skin and opens pores. Followed by deep tissue massage with Argan and Arnica oils. Skin glows, muscles surrender. Pure luxury.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%27m%20interested%20in%20Deep%20Tissue%20with%20Hamam%20premium%20package%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20details%20and%20availability.",
  },
  {
    id: "thai-jacuzzi",
    name: "Thai Massage With Jacuzzi Bath (Inc. steam)",
    shortDesc: "Traditional Thai massage followed by soothing Jacuzzi soak — perfect combination of stretch, pressure and hydrotherapy for total renewal.",
    image: "https://lh3.googleusercontent.com/p/AF1QipPU8X3Zhe6URxN7TnOLaHR0TW3t9NJYQbl0uRjV=s1360-w1360-h1020-rw",
    extraImages: [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=600&q=80",
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&q=80",
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&q=80",
    ],
    badge: "Premium",
    durations: [
      { label: "60 min", price: 5800 },
      { label: "90 min", price: 8000 },
      // { label: "120 min", price: 10000 },
    ],
    benefits: [
      "Improved flexibility and range",
      "Full hydrotherapy benefits",
      "Complete muscle relaxation",
      "Deep stress relief",
      "Total body renewal",
    ],
    products: [
      { icon: "flower2", name: "Thai Lemongrass Oil", desc: "energizing and muscle relaxing" },
      { icon: "droplets", name: "Jacuzzi Mineral Bath Salts", desc: "therapeutic mineral soak" },
      { icon: "droplets", name: "Coconut and Jasmine Body Lotion", desc: "post-treatment hydration" },
      { icon: "leaf", name: "Lavender Soak Crystals", desc: "added to Jacuzzi for relaxation" },
    ],
    whatToExpect:
      "Full Thai massage with assisted stretching and acupressure first. Then sink into warm Jacuzzi with Lavender crystals and mineral salts. Jets relax every remaining knot. You emerge completely renewed.",
    whatsapp:
      "https://wa.me/919535848946?text=Hi%2C%20I%27m%20interested%20in%20Thai%20Massage%20with%20Jacuzzi%20premium%20package%20at%20Vin%20Paradise%20Nagarbhavi.%20Please%20share%20details%20and%20availability.",
  },
];

export const testimonials = [
  {
    name: "Deveraj Nk",
    text: "This is my second time in vin paradise and I took 1hrs session. The therapist was Sonu. This time I had an awesome experience with her. She is really polite and professional.",
    rating: 5,
  },
  {
    name: "Kiran Suresh",
    text: "I have visited vin paradise today it's very good place to visit nice environment receptionist are very good staff are very polite one of the best spa to visit.",
    rating: 5,
  },
  {
    name: "Muthu gowda gowda",
    text: "I had a great massage at Vin Paradise Unisex Salon & Spa. Aishu is one of the best massage therapists I have ever had. She worked out the knots in my neck and shoulders. Great job, I highly recommend the spa.",
    rating: 5,
  },
  {
    name: "Pradeep Pradi",
    text: "Vin paradise unisex salon and spa is very good, the welcome is warm and the hospitality is very nice, the jacuzzi experience was wonderful, therapist sonu is very good. Soft spoken and caring.",
    rating: 5,
  },
];

export const galleryImages = [
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775645709/WhatsApp_Image_2026-04-08_at_16.22.44_jeropw.jpg",
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775645709/WhatsApp_Image_2026-04-08_at_16.22.45_tisyxe.jpg",
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775645708/WhatsApp_Image_2026-04-08_at_16.22.44_1_plkuv3.jpg",
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775088583/WhatsApp_Image_2026-04-01_at_13.04.23_q1zyfh.jpg",
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775088648/WhatsApp_Image_2026-04-01_at_13.04.24_ahyk4p.jpg",
  "https://res.cloudinary.com/dqp0pkern/image/upload/v1775088550/WhatsApp_Image_2026-04-01_at_13.04.22_epukvu.jpg",
];

export const whyChooseData = [
  {
    icon: "shield-check",
    title: "Highest Hygiene Standards",
    desc: "Strict hygiene protocols for every treatment. All tools sterilized, every surface sanitized. Your safety is our top priority.",
  },
  {
    icon: "user-check",
    title: "Expert & Certified Therapists",
    desc: "Professionally trained and certified team with years of experience in luxury spa and salon treatments.",
  },
  {
    icon: "sparkles",
    title: "Premium Products Only",
    desc: "Top-grade skin-safe products from trusted premium brands only. Zero compromise on quality ever.",
  },
  {
    icon: "users",
    title: "Unisex & Welcoming",
    desc: "Warm inclusive space for everyone — men, women, couples and families all warmly welcome.",
  },
  {
    icon: "badge-indian-rupee",
    title: "Affordable Luxury",
    desc: "World-class spa experiences at honest transparent prices. No hidden charges. Pure value.",
  },
  {
    icon: "target",
    title: "Personalized Treatments",
    desc: "Every client is unique. We customize every treatment to your skin type, body type and wellness goals.",
  },
];

export const PHONE = "9535848946";
export const WHATSAPP_DEFAULT = "https://wa.me/919535848946?text=Hi%2C%20I%20want%20to%20book%20a%20service%20at%20Vin%20Paradise%20Nagarbhavi";
